import { isBrowser } from 'toolkit/utils/isBrowser';

export type NetworkSwitcherOption = 'mainnet' | 'testnet';

const NETWORK_SWITCHER_LS_KEY = 'network_switcher_choice';

export function getStoredNetworkChoice(): NetworkSwitcherOption | null {
  if (!isBrowser()) {
    return null;
  }

  const value = window.localStorage.getItem(NETWORK_SWITCHER_LS_KEY);
  return value === 'mainnet' || value === 'testnet' ? value : null;
}

export function setStoredNetworkChoice(value: NetworkSwitcherOption) {
  if (!isBrowser()) {
    return;
  }

  window.localStorage.setItem(NETWORK_SWITCHER_LS_KEY, value);
}
